module.exports = {
	"192": {
		"name": "Uzbekistan",
		"mask": "+998",
		"length": 9
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/availableCountries/uz.json
// module id = 1818
// module chunks = 2